"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Colors = exports.Colors = {
	Primary: process.env.REACT_APP_Colors_Primary,
	Secondary: process.env.REACT_APP_Colors_Secondary,
	Tertiary: process.env.REACT_APP_Colors_Tertiary,
	PrimaryText: process.env.REACT_APP_Colors_PrimaryText,
	SecondaryText: process.env.REACT_APP_Colors_SecondaryText,
	TertiaryText: process.env.REACT_APP_Colors_TertiaryText,
	BrandAvatarColor: process.env.REACT_APP_Colors_BrandAvatarColor,

	MenuTextColor: process.env.REACT_APP_Colors_MenuTextColor,
	MenuButtonColor: process.env.REACT_APP_Colors_MenuButtonColor,
	MenuListColor: process.env.REACT_APP_Colors_MenuListColor,
	MenuListBgColor: process.env.REACT_APP_Colors_MenuListBgColor,
	MoreButtonColor: process.env.REACT_APP_Colors_MoreButtonColor,
	MoreButtonHoverColor: process.env.REACT_APP_Colors_MoreButtonHoverColor,
	MenuFooter: process.env.REACT_APP_Colors_MenuFooter,
	AricleCircleBg: process.env.REACT_APP_Colors_ArticleCircleBg,

	SecondaryLight: process.env.REACT_APP_Colors_SecondaryLight,
	StrokeVeryDark: process.env.REACT_APP_Colors_StrokeVeryDark,
	StrokeDark: process.env.REACT_APP_Colors_StrokeDark,
	StrokeMedium: process.env.REACT_APP_Colors_StrokeMedium,
	StrokeLight: process.env.REACT_APP_Colors_StrokeLight,
	StrokeVeryLight: process.env.REACT_APP_Colors_StrokeVeryLight,
	LightMode: process.env.REACT_APP_Colors_LightMode,
	DarkMode: process.env.REACT_APP_Colors_DarkMode,
	Error: process.env.REACT_APP_Colors_Error,
	Warning: process.env.REACT_APP_Colors_Warning,
	Success: process.env.REACT_APP_Colors_Success,
	Link: process.env.REACT_APP_Colors_Link,
	HeaderBarBackground: process.env.REACT_APP_Colors_HeaderBarBackground
};